<template>
  <div class="delivery-address-container">
    <div class="delivery-address-container__top">
      <div v-click-outside="closeDropdown" class="delivery-address-dropdown">
        <button :class="['delivery-address-dropdown__toggler', { 'delivery-address-dropdown__toggler--is-open': isDropdownOpen }]" @click="toggleDropdown()">
          <oie-format-address-se :address="defaultAddress"></oie-format-address-se>
          <oie-use-svg svg="caret"></oie-use-svg>
        </button>

        <div :class="['delivery-address-dropdown__content', { 'delivery-address-dropdown__content--is-open': isDropdownOpen }]">
          <ul class="delivery-address-dropdown__content-inner">
            <li>
              <button
                v-for="address of addresses"
                :key="address.id"
                class="delivery-address-dropdown__row-action"
                @click="selectToEditAddress(address.id)">
                <oie-format-address-se :address="address" :is-default="address.isPreferredAddress"></oie-format-address-se>

                <button class="delivery-address-dropdown__row-delete-action" @click.stop="deleteAddress(address.id)">
                  <oie-use-svg svg="trashcan"></oie-use-svg>
                </button>
              </button>
            </li>
          </ul>
        </div>
      </div>

      <oie-base-accordion-toggler
        :is-open="isAddressActionsOpen"
        :text="t('deliveryAddressCreateNewButton')"
        class="
        techinical-facts__toggler"
        @click="createNewAddress()"></oie-base-accordion-toggler>
    </div>

    <validation-observer
      v-show="isAddressActionsOpen"
      ref="observer"
      v-slot="{ invalid }"
      tag="form"
      class="delivery-address__form-container form-actions">
      <oie-address-component id="delivery" :address="selectedAddress"></oie-address-component>

      <oie-base-checkbox
        v-model="selectedAddress.isPreferredAddress"
        size="medium"
        is-for="delivery-address-make-default"
        :text="t('deliveryAddressMakeDefaultLabel')"
        css-classes="input-column__checkbox"></oie-base-checkbox>

      <div class="form-actions__action-elements">
        <oie-base-button
          v-if="isNewAddress"
          css-classes="button--with-border button--blue input-column__button"
          :text="t('deliveryAddressCreateNewButton')"
          @click="createAddress"></oie-base-button>

        <oie-base-button
          v-if="!isNewAddress"
          css-classes="button--with-border button--blue input-column__button"
          :text="tStatic('genericSave')"
          @click="updateAddress"></oie-base-button>

        <oie-base-button
          css-classes="button--no-background"
          :text="tStatic('modalCancel')"
          @click="cancelCreation"></oie-base-button>
      </div>
    </validation-observer>
  </div>
</template>

<script>
import httpService from '@/core/http-service'
import _ from 'lodash'

export default {
  data: () => ({
    isDropdownOpen: false,
    isAddressActionsOpen: false,
    selectedAddress: {
      id: null,
      name: null,
      addressLine1: null,
      addressCo: null,
      postalCode: null,
      city: null,
      countryCode: null,
      countryName: null,
      phone: null,
      isPreferredAddress: false
    },
    isNewAddress: false,
    defaultAddress: {},
    addresses: [],
    addressDeleted: false
  }),
  computed: {
    countryList() {
      return this.clientModel.countryList
    },
    defaultCountry() {
      return this.countryList.find(a => { return a.isDefault })
    },
    hasDefaultCountry() {
      return this.defaultCountry !== undefined
    }
  },
  mounted() {
    httpService.get('auth/getshippingaddresses').then((response) => {
      this.addresses = response.data
      this.defaultAddress = this.addresses.find(a => { return a.isPreferredAddress })
    })
  },
  methods: {
    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen
    },
    closeDropdown() {
      if (this.isDropdownOpen) {
        this.isDropdownOpen = false
      }
    },
    selectToEditAddress(id) {
      this.selectedAddress = this.addresses.filter(a => { return a.id === id })[0]
      this.isDropdownOpen = false
      this.isAddressActionsOpen = true
      this.isNewAddress = false
    },
    createNewAddress() {
      this.resetSelectedAddress()
      this.isAddressActionsOpen = !this.isAddressActionsOpen
      this.isNewAddress = true
    },
    updateAddress() {
      this.$refs.observer.validate().then((valid) => {
        if(valid) {
          httpService.post('auth/updateAddress', { dto: this.selectedAddress }).then((response) => {
            if(this.selectedAddress.isPreferredAddress) {
              _.forEach(this.addresses, (address) => {
                if(address.id !== this.selectedAddress.id) {
                  address.isPreferredAddress = false
                }
              })
            }
            this.isAddressActionsOpen = false
            this.isNewAddress = false
            this.defaultAddress = this.addresses.find(a => { return a.isPreferredAddress })
          })
            .catch((error) => {
              console.error('failed updating address for user', error)
            })
        }
      })
    },
    resetSelectedAddress() {
      this.selectedAddress = {
        id: null,
        name: null,
        addressLine1: null,
        addressCo: null,
        postalCode: null,
        city: null,
        countryCode: this.hasDefaultCountry ? this.defaultCountry.value : null,
        countryName: this.hasDefaultCountry ? this.defaultCountry.text : null,
        phone: null,
        isPreferredAddress: false
      }
    },
    createAddress() {
      this.$refs.observer.validate().then((valid) => {
        if(valid) {
          httpService.post('auth/createAddress', { dto: this.selectedAddress }).then((response) => {
            if(this.selectedAddress.isPreferredAddress) {
              _.forEach(this.addresses, (address) => {
                address.isPreferredAddress = false
              })
            }

            response.data.isPreferredAddress = this.selectedAddress.isPreferredAddress
            this.addresses.push(response.data)
            this.isAddressActionsOpen = false
            this.isNewAddress = false
            this.defaultAddress = this.addresses.find(a => { return a.isPreferredAddress })
          })
            .catch((error) => {
              console.error('failed updating address for user', error)
            })
        }
      })
    },
    cancelCreation() {
      this.isAddressActionsOpen = false
      this.isNewAddress = false
    },
    saveOrCreateAddress() {
      setTimeout(() => {
        if (this.selectedAddress.isDefault) {
          this.defaultAddress = this.selectedAddress
        }

        this.resetSelectedAddress()
        this.isAddressActionsOpen = false
      }, 3000)
    },
    deleteAdressRequest(id) {
      // todo: remove the address, this is triggered from the modal, triggered by deleteAddress below
      // 1. check if deleteAddress is a valid endpoint and add the correct data to it
      // 2. handle the removal of the address from the array (in some way)
      // 3. potentially close the dropdown with addresses (if not closed by outside click)

      if (id !== undefined) {
        httpService.delete('auth/deleteAddress', { addressId: id }).then((response) => {
          this.publish('modal.hide.generic')
          if (response.data.success) {
            this.addresses = response.data.addresses
            this.addressDeleted = true
            this.defaultAddress = this.addresses.find(a => { return a.isPreferredAddress })
          }
        })
      }
    },
    deleteAddress(id) {
      this.publish('modal.show.generic', { text: this.t('deliveryAddressConfirmDeleteAddressText'), buttons: [ { text: this.tStatic('genericDelete'), usePrimaryButton: true, handler: this.deleteAdressRequest, handlerParams: id } ] })
    }
  }
}
</script>

<style lang="scss">
.delivery-address-container {

  @include media(medium) {
    max-width: 50%;
  }
}

.delivery-address-container__top {
  padding: measure(full) 0;
  border: solid color(border-gray);
  border-width: 2px 0;
}

.delivery-address-dropdown {
  margin-bottom: measure(full);
}

.delivery-address-dropdown__toggler {
  @include reset-button;
  position: relative;
  width: 100%;
  height: 3.125rem;
  line-height: 1.75rem;
  padding: measure(eighth) measure(full) measure(eighth) measure(half);
  border: 1px solid color(border-gray);
  background-color: #FAFAFA;
}

.delivery-address-dropdown__toggler > svg {
  position: absolute;
  right: measure(half);
  width: 0.4375rem;
  height: 0.8125rem;
  transform: rotate(90deg) translateY(-50%);
}

.delivery-address-dropdown__toggler--is-open > svg {
  transform: rotate(90deg) translateY(-50%) scale(-1);
}

.delivery-address-dropdown__content {
  max-height: 0;
  overflow: hidden;
}

.delivery-address-dropdown__content--is-open {
  max-height: 30rem;
}

.delivery-address-dropdown__content-inner {
  list-style: none;
  max-height: 30rem;
  margin: 0;
  padding: measure(half);
  border: 1px solid color(border-gray);
  border-top: none;
  background-color: #FAFAFA;
  overflow-y: auto;
}

.delivery-address-dropdown__row-action {
  @include reset-button;
  width: 100%;
  height: 3.125rem;
  padding: measure(eighth) measure(eighth) measure(eighth) measure(half);
  border: 1px solid color(border-gray);
  border-top: none;
  background-color: color(background-white);
  line-height: 1.75rem;

  &:first-child {
    border-top: 1px solid color(border-gray);
  }
}

.delivery-address-dropdown__row-delete-action {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.5rem;
  height: 2.5rem;
  margin-left: auto;
  background-color: transparent;
  border: none;

  &:hover {
    cursor: pointer;
  }

  > svg {
    height: 100%;
    width: 17px;
  }
}

.delivery-address__form-container {
  padding-top: measure(full);
}
</style>
